import { CSSResultGroup, html } from 'lit'
import { customElement, property, query, state } from 'lit/decorators.js'
import { style } from './password-input.style.js'
import { ValueFormElement } from 'elements/_shared/formElement.js'
import { classMap } from 'lit/directives/class-map.js'
import { t } from '@cloudsuite/mosaic-shared/translations/translator.js'
import { formFieldValidationTypes } from 'elements/form-field/form-field.js'
import { initializeIconsByRole } from '@cloudsuite/mosaic-shared/icons/library.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'


initializeIconsByRole({
  'cse-password-input.eye': { name: 'eye', style: 'regular' },
  'cse-password-input.eye-slash': { name: 'eye-slash', style: 'regular' },
})

@customElement('cse-password-input')
export class CSEPasswordInput extends ValueFormElement {
  static override styles: CSSResultGroup = [hostStyle, style]

  @property({ type: String })
  override name = ''

  @property({ type: String })
  override value = ''

  @property({ type: Boolean })
  disabled: boolean = false

  @state()
  inputType: 'text' | 'password' = 'password'

  @property({ type: String })
  valid: formFieldValidationTypes[number] = 'none'

  @property({ type: Boolean })
  override autofocus = false

  @query('input')
  input!: HTMLInputElement

  private setValue = () => {
    this.value = this.input?.value ?? ''
    this.emit(this.value)
  }

  override focus() {
    this.input.focus()
  }

  override render() {
    return html`
      <div class="${classMap({
        'cse-password-input': true,
        'disabled': this.disabled,
        [`valid-${this.valid}`]: true,
      })}">
        <input
          value="${this.value}"
          type="${this.inputType}"
          ?disabled="${this.disabled}"
          ?autofocus="${this.autofocus}"
          @input="${this.setValue}"
          @change="${this.setValue}"
        />
        ${this.inputType === 'password' ?
          html`
            <cse-icon-button
              ?disabled="${this.disabled}"
              @click="${this.togglePasswordVisible}"
              aria-label="${t('show_password', { ns: 'cse-password-input', default: 'Show password' })}"
            >
              <cse-icon icon-role="cse-password-input.eye"></cse-icon>
            </cse-icon-button>`
          :
          html`
            <cse-icon-button
              ?disabled="${this.disabled}"
              @click="${this.togglePasswordInvisible}"
              aria-label="${t('hide_password', { ns: 'cse-password-input', default: 'Hide password' })}"
            >
              <cse-icon icon-role="cse-password-input.eye-slash"></cse-icon>
            </cse-icon-button>`
        }
      </div>
    `
  }

  togglePasswordVisible() {
    if (this.disabled) return

    this.inputType = 'text'
  }

  togglePasswordInvisible() {
    if (this.disabled) return

    this.inputType = 'password'
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cse-password-input': CSEPasswordInput
  }
}
